import React from 'react';
import { Checkbox, Spin } from 'antd';
import { useQuery } from 'react-query';
import {  getRoles } from '../../../api'; //

interface RoleSelectProps {
  selected: string[];
  onChange: (roles: string[]) => void;
  applicationId: string;
}

const RoleSelect: React.FC<RoleSelectProps> = ({ selected, onChange, applicationId }) => {
  const { data: availableRoles, isLoading, error } = useQuery(
    ['roles', applicationId],
    () => getRoles(applicationId),
    {
      enabled: !!applicationId,
    }
  );
console.log("roleapp", availableRoles)
  const handleRoleChange = (role: string, checked: boolean) => {
    const newRoles = checked 
      ? [...selected, role] 
      : selected.filter(r => r !== role);
    onChange(newRoles);
  };

  if (isLoading) return <Spin size="small" />;
  if (error) return <div className="text-red-500 text-sm">Erreur de chargement des rôles</div>;

  return (
    <div className="border border-gray-200 rounded-md p-4 mt-1">
      <div className="space-y-2">
        {availableRoles.data?.map((role: any) => (
          <div key={role.id} className="flex items-center">
            <Checkbox
              checked={selected.includes(role.name)}
            onChange={(e) => handleRoleChange(role.name, e.target.checked)}
            >
              <span className="ml-2">{role.name}</span>
            </Checkbox>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoleSelect;